// removed by extract-text-webpack-plugin
module.exports = {"grid":"Lefjgljk3rpdU2GYAzCOI","column":"ZIUn7FFhBWtms7eszlWJu"};